import AlertTab from "./AlertTab";

export default AlertTab;